import {PatientTherapySequence} from '@cypro/engine/schema'
import {Suspense} from 'react'
import {ReturnToPharmacyDialog} from './return-to-pharmacy-dialog'
import {dialog} from '@cypro/ui/components'
import {PatientTherapySequenceProvider} from '@/shared/contexts/patient-therapy-sequence-context'

export function openReturnToPharmacyDialog(sequence: PatientTherapySequence) {
  return dialog.open('return-to-pharmacy-dialog', {
    id: 'return-to-pharmacy-dialog',
    children: (
      <Suspense fallback={null}>
        <PatientTherapySequenceProvider sequenceId={sequence.id}>
          <ReturnToPharmacyDialog sequence={sequence} />
        </PatientTherapySequenceProvider>
      </Suspense>
    ),
  })
}
